<template>
    <div class="terms-consent">
        <label class="terms-consent--label">
            <input
                type="checkbox"
                class="terms-consent--input"
                :checked="agreed"
                @change="onChange"
            >
            <span class="terms-consent--text">
                I agree to the
                <router-link to="/terms" target="_blank">Terms of Service</router-link>
                and
                <router-link to="/terms" target="_blank">Refund Policy</router-link>.
                I understand I am buying a license to virtual items with no real-world
                value, that delivery is immediate, and that all sales are final. I confirm
                I am the account holder or an authorized user of the payment method used,
                and that I am 18 or older, or have my parent or guardian's consent.
            </span>
        </label>
    </div>
</template>

<script>
export default {
    name: "TermsConsentCheckbox",
    data() {
        return {
            agreed: false
        }
    },
    methods: {
        onChange(event) {
            this.agreed = event.target.checked
            this.$emit("change", {
                agreed: this.agreed,
                agreedAt: this.agreed ? new Date().toISOString() : null
            })
        }
    }
}
</script>

<style scoped>
.terms-consent {
    margin-bottom: 1rem;
}

.terms-consent--label {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    cursor: pointer;
}

.terms-consent--input {
    margin-top: 0.25rem;
    flex-shrink: 0;
}

.terms-consent--text {
    font-size: 0.85rem;
    line-height: 1.35;
}

.terms-consent--text a {
    text-decoration: underline;
}
</style>
